import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import {
  createEventBus,
  getDispatchData,
  removeEventBus,
} from '@/util/eventBus'

const SHOW_DOC_VIEWER = `evtbus-show-document-viewer`

export interface ShowViewerOption {
  show: boolean
  filename: string
  url: string
}

@Component
export default class DocumentViewer extends Vue {
  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  filename: string = ''
  url: string = ''
  show: boolean = false

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  created() {
    createEventBus(window, SHOW_DOC_VIEWER, this.open)
  }

  beforeDestroy() {
    removeEventBus(window, SHOW_DOC_VIEWER, this.open)
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  handleClose() {
    this.show = false
  }

  open(data: any) {
    const payload = getDispatchData<ShowViewerOption>(SHOW_DOC_VIEWER)
    if (payload) {
      const { filename, url, show } = payload
      this.show = show
      this.filename = filename
      this.url = url
    } else {
      console.error('INVALID_OPERATION_ERROR : cannot open doc-vierwer(payload is null)')
    }
  }
}
